import React, { useState } from "react";
import { Link } from "react-router-dom";
import { postApi } from "../services/api/api";
import { toast } from "react-toastify";

function Footer() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      toast.error("Please enter your email address");
      return;
    }

    if (!validateEmail(trimmedEmail)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await postApi("/newsletter/subscribe", { email: trimmedEmail });

      if (response.success) {
        toast.success(response.message || "Successfully subscribed to newsletter!");
        setEmail("");
      } else {
        toast.error(response.message || "Subscription failed. Please try again.");
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || "Something went wrong. Please try again later.";
      toast.error(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <div className="footer-links">
              <ul>
                <li><Link to="/AboutUs">Our Story</Link></li>
                
                {/* <li><a href="/community-forum">Community Forum</a></li> 
                <li><Link to="/PetRegistration">Pet Registration</Link></li>*/}
                {/* <li><a href="/pet-events">Pet Events</a></li> */}
                <li><Link to="/ServicesListing">Services</Link></li>
                <li><Link to="/ContactUs">Contact Us</Link></li>
                <li><Link className="nav-link"  data-bs-toggle="modal" data-bs-target="#RegistrationModal">
                                    Sign Up
                                  </Link></li>
              </ul>
            </div>
          </div>

          <div className="col-md-3">
            <div className="footer-links">
              <ul>
              {/* <li><Link to="/ServicesListing">Services</Link></li>
                <li><Link to="/Adoption">Adoption</Link></li>
                 <li><a href="/trainers">Trainers</a></li> */}
                {/* <li><a href="/pet-sitters">Pet Sitters</a></li> */}
                {/* <li><a href="/groomers">Groomers</a></li> */}
                {/* <li><a href="/veterinary-services">Veterinary Services</a></li> */}
              </ul>
            </div>
          </div>

          <div className="col-md-6">
          <form className="newsletter-form" onSubmit={handleSubscribe}>

            <div className="newsletter">
                <input
                  type="email"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                />
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Subscribing..." : "Send"}
                </button>
              
            </div>
            </form>
              <p className="f_text">Or connect with us:</p>
               <a className="email_txtx" href="mailto:everythingpawzible@gmail.com">everythingpawzible@gmail.com</a>
            <div className="socials">
  <a
    href="https://instagram.com/everythingpawzible.india"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-instagram"></i>
  </a>

  <a
    href="https://facebook.com"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-facebook-f"></i>
  </a>

  <a
    href="https://linkedin.com"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-linkedin-in"></i>
  </a>

  <a
    href="https://wa.me/your-number"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-whatsapp"></i>
  </a>
</div>
          </div>
        </div>
      </div>

      <div className="copyright">
        All Rights Reserved 2025 everythingpawzible
      </div>
    </footer>
  );
}

export default Footer;
